/* eslint-disable react/no-danger */
import React, { useContext } from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { UXRefreshToggleContext } from '@bingads-webui-react/preference-utility';
import { buttonStyle, buttonStyleNew } from './styles';

import type { TopBannerMessageWrapperProps } from '../types';

// This is to split server-side returned <a> element in message and convert to button style
export function ButtonWrapper(props: TopBannerMessageWrapperProps) {
  const { message } = props;
  const { isUXRefreshEnabled } = useContext(UXRefreshToggleContext);
  const classes = useDefaultStyles(isUXRefreshEnabled ? buttonStyleNew : buttonStyle);

  const doc = (new DOMParser()).parseFromString(message, 'text/html');
  const aElements = doc.body.getElementsByTagName('a');

  if (aElements.length <= 0) {
    return (<span className={classNames('notification-center-top-banner-message', classes.content)} title={doc.body.innerText} dangerouslySetInnerHTML={{ __html: doc.body.innerHTML }} />);
  }

  const aTags = (Array.prototype.slice.call(aElements) as HTMLAnchorElement[]).map((el: HTMLAnchorElement) => {
    const aTag = doc.body.removeChild(el);
    aTag.classList.add(classes.button);
    if (!aTag.style.color) {
      aTag.style.color = 'black';
    }
    return aTag.outerHTML;
  }).join('');

  return (
    <>
      <span className={classNames('notification-center-top-banner-message', classes.content)}>{doc.body.innerHTML}</span>
      <span className={classNames('notification-center-top-banner-action', classes.calloutTargetContainer)} dangerouslySetInnerHTML={{ __html: aTags }} />
    </>
  );
}
